"use client";
import Button from "@marginly/ui/components/button";
import Noop from "@marginly/ui/components/helpers/noop";
import T from "@marginly/ui/components/typography";
import cn from "classnames";
import NextLink from "next/link";
import React, { useState } from "react";
import { useContext } from "react";
import { useAccount } from "wagmi";

import ClientOnly from "@/components/util/client-only";
import { Web3Context } from "@/contexts/web3/context";
import { useMarginlyApi } from "@/hooks/api";
import { numberFormatter } from "@/util/formatters";

import { AirdropButton, ButtonsRow } from "../../navigation/styled";
import { WalletModalLight } from "../../navigation/wallet-modal-light";
import { AirdropHeader, HeaderContainer, HeaderLogo } from "../styled";

export function Header() {
  const account = useAccount();
  const [isWalletModalVisible, setIsWalletModalVisible] = useState(false);

  const hideWalletModal = () => {
    document.body.style.overflow = "visible";
    setIsWalletModalVisible(false);
  };

  const { data: userPoints } = useMarginlyApi({
    enabled: Boolean(account.address),
    endpoint: "userPoints",
    args: [account.address],
  });

  const pointBalance = userPoints?.balance || 0;
  const { open } = useContext(Web3Context);

  return (
    <AirdropHeader>
      <HeaderContainer>
        <HeaderLogo href="https://app.marginly.com/arbitrum">
          <img src="/images/airdrop/logotype.png" alt="" className="desktop" />
          <img src="/images/airdrop/logo-m.png" alt="" className="mobile" />
        </HeaderLogo>
        <ClientOnly>
          <ButtonsRow>
            <NextLink href="/sparks">
              <AirdropButton>
                <img src="/images/airdrop/airdrop-btn.svg" alt="" />
                <T action>
                  {pointBalance
                    ? numberFormatter(Math.ceil(pointBalance))
                    : "Get Sparks"}
                </T>
              </AirdropButton>
            </NextLink>
            {!account.address ? (
              <Button md text icon onClick={() => open({ view: "Connect" })}>
                <img
                  src="/images/airdrop/arbitrum-one.svg"
                  alt=""
                  style={{ filter: "invert(var(--svg-invert))" }}
                />
                <T
                  action
                  style={{
                    fontWeight: 400,
                    fontVariationSettings: `"wght" 700`,
                    color: `#fff`,
                  }}
                >
                  Connect
                </T>
              </Button>
            ) : (
              <Button
                onClick={() => {
                  document.body.style.overflow = "hidden";
                  setIsWalletModalVisible(true);
                }}
                className={cn(
                  account.address == null && "no-address",
                  "selected-network",
                  "airdrop-page",
                )}
                md
                icon
              >
                {/* <img src={getNetworkIcon(chain.id)} alt="" /> */}
                {account.address ? (
                  <T action> ..{account?.address?.slice(-4)}</T>
                ) : (
                  <Noop />
                )}
              </Button>
            )}
          </ButtonsRow>
        </ClientOnly>
        {isWalletModalVisible ? (
          <WalletModalLight
            onHide={hideWalletModal}
            onConnectClick={() => open({ view: "Connect" })}
          />
        ) : (
          <Noop />
        )}
      </HeaderContainer>
    </AirdropHeader>
  );
}
